import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';
import { LocationService } from '../proxy/planning/controllers/location.service';
import { ZoneService } from '../proxy/planning/controllers/zone.service';
import { RegionService } from '../proxy/planning/controllers/region.service';
import { DepartmentService } from '../proxy/planning/controllers/department.service';
import { ThirdPartyPropertyCategoryService } from '../proxy/planning/controllers/third-party-property-category.service';
import { ForestryManagementService } from '../proxy/planning/controllers/forestry-management.service';
import { VendorService } from '@controlling/proxy/controlling/controllers/vendor.service';

import { SupplyRegisterPerThirdPartyProperty } from '../supply-register-per-third-party-property/supply-register-per-third-party-property';
FieldBuilder.setNamespace('Planning');

export const THIRDPARTYPROPERTY_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.ThirdPartyProperty.Name')
    .required()
    .minLength(1)
    .maxLength(50)
    .build(),
  FieldBuilder
    .text('mgsCode', 'Entity.ThirdPartyProperty.MgsCode')
    .required()
    .minLength(1)
    .maxLength(8)
    .build(),
  FieldBuilder
    .foreignKey('forestryManagementId', 'Entity.ForestryManagement', ForestryManagementService)
    .display('certificationCode.name')
    .build(),
  FieldBuilder
    .number('treeVolume', 'Entity.ThirdPartyProperty.TreeVolume')
    .required()
    .decimal(2,10)
    .build(),
  FieldBuilder
    .checkbox('isFscCertified', 'Entity.ThirdPartyProperty.IsFscCertified')
    .readOnly()
    .build(),
  FieldBuilder
    .checkbox('isPefcCertified', 'Entity.ThirdPartyProperty.IsPefcCertified')
    .readOnly()
    .build(),
  FieldBuilder
    .foreignKey('zoneId', 'Entity.Zone', ZoneService)
    .displayFromNested('zone.name')
    .sortBy('zone.name')
    .build(),
  FieldBuilder
    .foreignKey('regionId', 'Entity.Region', RegionService)
    .required()
    .displayFromNested('region.name')
    .sortBy('region.name')
    .build(),
  FieldBuilder
    .foreignKey('departmentId', 'Entity.Department', DepartmentService)
    .displayFromNested('department.name')
    .sortBy('department.name')
    .build(),
  FieldBuilder
    .foreignKey('thirdPartyPropertyCategoryId', 'Entity.ThirdPartyPropertyCategory', ThirdPartyPropertyCategoryService)
    .displayFromNested('thirdPartyPropertyCategory.description')
    .sortBy('thirdPartyPropertyCategory.description')
    .build(),
  FieldBuilder // TODO: when the orchestrator is implemented, refactor this nested logic into it
    .foreignKey('ownerVendorId', 'Entity.ThirdPartyProperty.OwnerVendor', VendorService)
    .required()
    .display('fantasyName')
    .keyField('id')
    .build(),
  FieldBuilder // TODO: when the orchestrator is implemented, refactor this nested logic into it
    .foreignKey('exporterVendorId', 'Entity.ThirdPartyProperty.ExporterVendor', VendorService)
    .required()
    .display('fantasyName')
    .keyField('id')
    .build(),
  FieldBuilder
    .foreignKey('locationId', 'Entity.Location', LocationService)
    .required()
    .displayFromNested('location.name')
    .sortBy('location.name')
    .hideInChildForms()
    .build(),
];

export const THIRDPARTYPROPERTY_CONFIG = {
  entityName: 'ThirdPartyProperty',
  localizationKey: 'Planning::Entity.ThirdPartyProperty',
  permission: 'ControllingContract.ThirdPartyProperties',
  fields: THIRDPARTYPROPERTY_FIELDS,

  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Contracts + MENU_NAME_SUFFIX,
  children: [
    {
      entityName: 'SupplyRegisterPerThirdPartyProperty',
      foreignKeyField: 'thirdPartyPropertyId',
      localizationKey: 'Planning::Entity.SupplyRegisterPerThirdPartyProperty',
      component: SupplyRegisterPerThirdPartyProperty,
    },
  ],
};
